import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginBenefits = () => {
  const benefits = [
    {
      icon: 'Users',
      title: 'Collaborative Teams',
      description: 'Join interdisciplinary teams with developers, designers, and analysts to solve real city challenges.'
    },
    {
      icon: 'BookOpen',
      title: 'Learning Pathways',
      description: 'Access role-specific courses in IoT, AI, GIS, and Smart City Design with micro-certifications.'
    },
    {
      icon: 'MessageSquare',
      title: 'Direct Communication',
      description: 'Connect directly with city officials, mentors, and team members through integrated messaging.'
    },
    {
      icon: 'Award',
      title: 'Real Impact',
      description: 'Work on actual city problems and see your solutions implemented in smart city initiatives.'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="text-center lg:text-left">
        <h2 className="text-3xl font-bold text-foreground mb-4">
          Transform Cities Through Innovation
        </h2>
        <p className="text-lg text-muted-foreground leading-relaxed">
          Join the Smart Cities Onboarding Platform where students and city officials collaborate 
          to create sustainable, technology-driven solutions for urban challenges.
        </p>
      </div>
      {/* Benefits Grid */}
      <div className="grid gap-6">
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start space-x-4 group">
            <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-micro">
              <Icon name={benefit?.icon} size={24} className="text-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-foreground mb-2">{benefit?.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Stats */}
      <div className="grid grid-cols-3 gap-4 pt-8 border-t border-border">
        <div className="text-center">
          <div className="text-2xl font-bold text-primary mb-1">50+</div>
          <div className="text-xs text-muted-foreground">Cities Partnered</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-primary mb-1">1,200+</div>
          <div className="text-xs text-muted-foreground">Students Engaged</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-primary mb-1">300+</div>
          <div className="text-xs text-muted-foreground">Solutions Delivered</div>
        </div>
      </div>
    </div>
  );
};

export default LoginBenefits;